import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwMessageModule } from '../sw-message/sw-message.module';
import { SwToolbarComponent } from "./sw-toolbar/sw-toolbar.component";
import { SwGridTableComponent } from './sw-grid-table/sw-grid-table.component';
import { SwTableTreeComponent } from './sw-table-tree/sw-table-tree.component';
import { SwFilterComponent } from './sw-filter/sw-filter.component';
import { SwLevelTableComponent } from './sw-level-table/sw-level-table.component';
import { SwCrumbsComponent } from './sw-crumbs/sw-crumbs.component';
import { FormsModule } from '@angular/forms';
import { SwTabControlComponent } from './sw-tab-control/sw-tab-control.component';
import { SwOrderComponent } from './sw-order/sw-order.component';
import { SwFilterSearchComponent } from './sw-filter-search/sw-filter-search.component';

@NgModule({
  imports: [CommonModule, SwMessageModule,FormsModule],
  declarations: [SwGridTableComponent, SwTableTreeComponent, SwToolbarComponent,SwFilterComponent, SwLevelTableComponent, SwCrumbsComponent,SwTabControlComponent,SwOrderComponent,SwFilterSearchComponent],  
  providers: [],
  exports:[SwGridTableComponent, SwTableTreeComponent, SwToolbarComponent,SwFilterComponent,SwLevelTableComponent,SwCrumbsComponent,SwTabControlComponent,SwOrderComponent,SwFilterSearchComponent]
})
export class SwTableModule {
  
}
